
export default {
  name: 'AnalyzeCondition',
  props: {
    conditions: {
      type: Object,
      default: null
    },
    condition_jp: {
      type: Object,
      default: null
    },
    items: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    // items: [
    //   {
    //     productNames: [
    //       '食用油',
    //       'スープ',
    //       '麺類'
    //     ],
    //     title: 'カテゴリ種別1'
    //   },
    //   {
    //     productNames: [
    //       '食用油1',
    //       'スープ2',
    //       '麺類3'
    //     ],
    //     title: 'カテゴリ種別2'
    //   }
    // ]
  })
}
